import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '@/store/authStore';

interface OwnerOnlyRouteProps {
  children: React.ReactNode;
}

const OwnerOnlyRoute: React.FC<OwnerOnlyRouteProps> = ({ children }) => {
  const user = auth.getUser();

  if (!user.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'parent') {
    return <Navigate to="/my-bookings" replace />;
  }

  if (!user.isOrganizationOwner) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default OwnerOnlyRoute;
